import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "section page" }
const _hoisted_2 = { class: "title has-text-green is-size-4 has-text-weight-semibold" }
const _hoisted_3 = { class: "columns h-100" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "h-100 left" }
const _hoisted_6 = { class: "ml-2" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "h-100 right" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "is-size-3 mdi mdi-chevron-right" })
], -1 /* HOISTED */)
const _hoisted_9 = {
  key: 0,
  class: "column is-9 h-100"
}
const _hoisted_10 = { class: "box h-100 w-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('preferences.title')), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: _normalizeClass(["column", {'is-3': _ctx.expanded, 'is-12': !_ctx.expanded}])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menu, (entry) => {
          return (_openBlock(), _createElementBlock("div", {
            key: entry.id,
            class: "box preference-entry",
            onClick: ($event: any) => (_ctx.toggle(entry.id))
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", {
                class: "entry-icon",
                style: _normalizeStyle({ 'background-color': entry.iconBackgroundColor })
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(["mdi has-text-white is-size-3", entry.icon])
                }, null, 2 /* CLASS */)
              ], 4 /* STYLE */),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", null, _toDisplayString(entry.title), 1 /* TEXT */),
                (!_ctx.expanded)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(entry.subtitle), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _hoisted_8
          ], 8 /* PROPS */, _hoisted_4))
        }), 128 /* KEYED_FRAGMENT */))
      ], 2 /* CLASS */),
      (_ctx.expanded)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.current.component)))
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}